import styled from 'styled-components';
import { palette } from 'styled-tools';

export const StyledHr = styled.hr<{
	$height: number;
	$color: string;
	$opacity: number;
}>`
	border: none;
	height: ${props => props.$height}px;
	background-color: ${props => palette(props.$color)};
	background-image: ${props => palette(props.$color)};
	opacity: ${props => props.$opacity};
`;
